export default __webpack_public_path__ + "static/ProValue_1-7a752f10fa900c390912920ec419f4b7.webp";